<template>
    <v-form @submit.prevent="onSubmit">
        <v-row>
            <v-col cols="12">
                <v-select v-model="$v.form.warehouses.$model"
                          :label="$t('users.assigned_warehouses')"
                          :hint="$t('users.assigned_warehouses_hint')"
                          required
                          :error-messages="warehousesErrors"
                          @input="$v.form.warehouses.$touch()"
                          @blur="$v.form.warehouses.$touch()"
                          :items="warehouses"
                          item-value="id"
                          item-text="name"
                          multiple
                          chips
                          deletable-chips
                          persistent-hint
                          :loading="isBusy"
                >
                    <template v-slot:item="{item, attrs, on}">
                        <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                            <v-list-item-action>
                                <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <v-row no-gutters align="center">
                                        {{ item.name }}
                                    </v-row>
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-switch
                                    v-model="form.requires_approval[item.id]"
                                    :label="$t('users.requires_approval').toLowerCase()"
                                    @click.native.stop="() => {}"
                                    dense
                                    hide-details
                                />
                            </v-list-item-action>
                        </v-list-item>
                    </template>
                </v-select>
            </v-col>
            <v-col cols="12">
                <v-btn type="submit" color="primary" dark :disabled="isBusy">
                    {{ $t('warehouses.save') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import {API} from "@/api/api";
import {validationMixin} from "vuelidate";
import SnackbarMixin from "@/mixins/SnackbarMixin";

export default {
    name: "EditUsersToWarehouseForm",
    mixins: [validationMixin, SnackbarMixin],
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        // loading
        isBusySubmit: false,
        isBusyWarehouses: false,
        isBusyUserWarehouses: false,
        // enum
        warehouses: [],
        // form data
        form: {
            warehouses: [],
            requires_approval: {}
        }
    }),
    validations: {
        form: {
            warehouses: {},
            requires_approval: {}
        }
    },
    computed: {
        isBusy() {
            return this.isBusySubmit || this.isBusyWarehouses || this.isBusyUserWarehouses
        },
        warehousesErrors() {
            return [] // TODO
        }
    },
    methods: {
        onSubmit() {
            const data = {
                warehouses: this.form.warehouses.map(warehouseId => ({
                    warehouse: warehouseId,
                    requires_approval: warehouseId in this.form.requires_approval
                        && this.form.requires_approval[warehouseId] === true
                }))
            }

            this.isBusySubmit = true;
            API.put('/api/users/' + this.user.id + '/warehouses', data)
                .then(() => {
                    this.snackbarSuccess(this.$t('snackbar.warehouses_to_user_assigned'))
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusySubmit = false;
                })
        },
        fetchWarehouses() {
            this.isBusyWarehouses = true
            API.get('/api/warehouses')
                .then(response => {
                    this.warehouses = response.data;
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusyWarehouses = false;
                })
        },
        fetchUserWarehouses() {
            this.isBusyUserWarehouses = true
            API.get('/api/users/' + this.user.id + '/warehouses')
                .then(response => {
                    response.data.forEach(item => {
                        this.form.warehouses.push(item.warehouse.id)
                        this.form.requires_approval[item.warehouse.id] = item.requires_approval
                    })
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusyUserWarehouses = false;
                })
        }
    },
    created() {
        this.fetchWarehouses()
        this.fetchUserWarehouses()
    }
}
</script>
